const CAPTION = "image-caption";
const ADD_CAPTION_BUTTON = "add-caption-button";
export {
  ADD_CAPTION_BUTTON,
  CAPTION
};
//# sourceMappingURL=data-hooks.js.map
